import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e87abb00"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-describedby"]
const _hoisted_2 = { class: "work__wrapper" }
const _hoisted_3 = {
  class: "work__image",
  ref: "figureRef"
}
const _hoisted_4 = ["data-src", "alt", "src", "width", "height", "aria-describedby"]
const _hoisted_5 = ["aria-describedby"]
const _hoisted_6 = ["aria-describedby"]
const _hoisted_7 = ["aria-describedby"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "work__item",
    "aria-describedby": _ctx.title
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("figure", _hoisted_3, [
        _createElementVNode("img", {
          class: "lazy loaded",
          "data-src": _ctx.banner,
          alt: _ctx.title,
          src: require(`@/assets/images/works/${_ctx.id}/${_ctx.banner}`),
          width: _ctx.width,
          height: _ctx.height,
          loading: "lazy",
          decoding: "async",
          "aria-describedby": `${_ctx.title} preview image`
        }, null, 8, _hoisted_4)
      ], 512)
    ]),
    _createElementVNode("article", null, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", {
          class: "work__title",
          "aria-describedby": _ctx.title
        }, _toDisplayString(_ctx.title), 9, _hoisted_5),
        _createElementVNode("h4", {
          class: "work__tags",
          "aria-describedby": `${_ctx.title} technologies`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.technologyTags, (tag) => {
            return (_openBlock(), _createElementBlock("span", {
              key: tag,
              class: "work__tag"
            }, _toDisplayString(tag), 1))
          }), 128))
        ], 8, _hoisted_6),
        _createElementVNode("p", {
          class: _normalizeClass(["work__project_type", _ctx.projectTypeClass])
        }, _toDisplayString(_ctx.projectType), 3),
        _createElementVNode("p", {
          class: "work__information",
          "aria-describedby": `${_ctx.title} overview`
        }, _toDisplayString(_ctx.info), 9, _hoisted_7),
        _createElementVNode("button", {
          role: "button",
          class: "work__link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
        }, " More about this project ")
      ])
    ])
  ], 8, _hoisted_1))
}